(function(root){
  'use strict';
  var VERSION='2026-10-04.1';
  var BUILD='2026-10-17.2';
  function boot(doc,win){
    var body=doc.body;if(!body||!body.dataset.nbArticleId||body.dataset.nbCtaMeasured)return;
    body.dataset.nbCtaMeasured=BUILD;
    var qa=new URLSearchParams(win.location.search).get('nb_cta_qa')==='1';
    var base={version:VERSION,article_id:body.dataset.nbArticleId,locale:body.dataset.nbArticleLocale.split('-')[0],
      market:body.dataset.nbArticleMarket,device:win.innerWidth<768?'mobile':win.innerWidth<1100?'tablet':'desktop',qa:qa};
    var anonymous=new Set(),consented=new Set(),timers=new Map(),observers=[],pageview=null,refreshTimer=null;
    function allowed(){try{return win.Shopify.customerPrivacy.analyticsProcessingAllowed()===true;}catch(_){return false;}}
    function publish(data,key){
      if(!allowed()||consented.has(key))return;
      if(data.stage==='visible_click'&&(!consented.has('visible:'+data.position+':'+data.destination)||!consented.has('click:'+data.position+':'+data.destination)))return;
      try{
        if(!win.Shopify.analytics||!win.Shopify.analytics.publish)return;
        if(!pageview){var bytes=new Uint32Array(4);win.crypto.getRandomValues(bytes);pageview=Array.from(bytes,function(v){return v.toString(16).padStart(8,'0');}).join('');}
        consented.add(key);
        var result=win.Shopify.analytics.publish('nordbelt:blog_cta',Object.assign({},data,{pageview_id:pageview,origin:win.location.origin}));
        if(result&&result.catch)result.catch(function(){consented.delete(key);});
      }catch(_){consented.delete(key);}
    }
    function emit(stage,position,destination){
      var data=Object.assign({},base,{stage:stage,position:position,destination:destination});
      var key=[stage,position,destination].join(':');
      if(!anonymous.has(key)){
        anonymous.add(key);
        try{win.fetch('https://nordbelt-attribution.nordbelt-attribution.workers.dev/v1/blog-cta-counts',{
          method:'POST',mode:'cors',credentials:'omit',referrerPolicy:'no-referrer',cache:'no-store',keepalive:true,
          headers:{'Content-Type':'text/plain'},body:JSON.stringify(data)}).catch(function(){});}catch(_){}
      }
      publish(data,key);
      if((stage==='visible'||stage==='click')&&anonymous.has('visible:'+position+':'+destination)&&anonymous.has('click:'+position+':'+destination))emit('visible_click',position,destination);
    }
    function position(node){
      if(node.closest('.buybar,[data-buybar]'))return 'buybar';
      if(node.closest('.site-header,[data-nb-site-header],header'))return 'header';
      if(node.closest('.nb-railv2'))return 'rail';
      if(node.closest('[data-nb-protocol-optin]'))return node.closest('.nb-rte')?'protocol':'tail_protocol';
      var card=node.closest('[data-nb-blog-cta],[data-nb-category-cta],.nb-offer');
      if(card)return card.dataset.position||'bridge';
      return node.closest('.nb-rte')?'body_link':'homepage_tail';
    }
    function destination(node){
      if(node.hasAttribute('data-nb-quick-add')||node.hasAttribute('data-nb-cart-open')||node.closest('[data-nb-product-form]'))return 'cart';
      if(node.closest('[data-nb-protocol-optin]')&&node.tagName==='BUTTON')return 'protocol';
      try{
        var url=new URL(node.href,win.location.href);
        // Only Nordbelt destinations belong in the storefront conversion path.
        // In particular, an external /products/ URL is not a Nordbelt product.
        if(url.origin!==win.location.origin&&!/^(?:www\.)?nordbelt\.(?:com|nl)$/.test(url.hostname))return null;
        var path=url.pathname.replace(/\/+$/,'')||'/';
        var route=path.replace(/^\/[a-z]{2}(?:-[a-z]{2,3})?(?=\/|$)/i,'')||'/';
        if(/^\/(?:collections\/[^/]+\/)?products\/[^/]+$/.test(route))return 'product';
        if(route==='/pages/how-to-guide')return 'guide';
        if(/^\/pages\/(?:fysiopraktijken|sportverenigingen|teams-clubs|business-pricing)$/.test(route))return 'professional';
        if(route==='/pages/training-protocol')return 'protocol';
        if(/^\/checkouts?(?:\/|$)/.test(route))return 'checkout';
        if(/^\/cart(?:\/|$)/.test(route))return 'cart';
        var routeRoot=win.Shopify&&win.Shopify.routes&&win.Shopify.routes.root;
        if(!routeRoot){
          // Older documents may lack Shopify.routes. The current page prefix
          // supplies the same locale/market root without accepting any slug.
          var prefix=new URL(win.location.href).pathname.match(/^\/([a-z]{2}(?:-[a-z]{2,3})?)(?:\/|$)/i);
          routeRoot=prefix?'/'+prefix[1]:'/';
        }
        var homePath=new URL(routeRoot,win.location.origin).pathname.replace(/\/+$/,'')||'/';
        if(path===homePath||/^\/(?:[a-z]{2})?$/.test(path))return 'home';
      }catch(_){}
      return null;
    }
    // Classify ordinary guide/home links too; destination() excludes citations
    // and unrelated articles, while the existing sets deduplicate each stage.
    var selector='.nb-rte a[href],.nb-railv2 .btn,.nb-railv2__more,'+
      'header [data-nb-quick-add],.site-header [data-nb-quick-add],[data-nb-site-header] [data-nb-quick-add],.buybar button,'+
      'main [data-nb-quick-add],main [data-nb-product-form] button[type="submit"],main .hero .btn,'+
      'main [data-nb-protocol-optin] button[type="submit"],main [data-nb-protocol-download-link]';
    function rendered(node){
      if(node.closest('[hidden],[inert],[aria-hidden="true"]')||!node.getClientRects().length)return false;
      var style=win.getComputedStyle(node);
      return style.display!=='none'&&style.visibility!=='hidden'&&Number(style.opacity)!==0;
    }
    function visible(node){
      if(doc.visibilityState==='hidden'||!rendered(node))return false;
      var r=node.getBoundingClientRect(),area=r.width*r.height;
      var overlap=Math.max(0,Math.min(r.bottom,win.innerHeight)-Math.max(r.top,0))*Math.max(0,Math.min(r.right,win.innerWidth)-Math.max(r.left,0));
      return area>0&&overlap/area>=.5;
    }
    function observe(){
      observers.forEach(function(o){o.disconnect();});observers=[];timers.forEach(function(t){win.clearTimeout(t);});timers.clear();
      Array.from(doc.querySelectorAll(selector)).forEach(function(node){
        var p=position(node),d=destination(node);if(!d)return;
        if(rendered(node))emit('render',p,d);
        if(!win.IntersectionObserver)return;
        // Observe initially hidden actions too: the mobile buybar and active
        // copy sets can appear after boot without a consent or tab change.
        var observer=new win.IntersectionObserver(function(entries){entries.forEach(function(e){
          win.clearTimeout(timers.get(node));timers.delete(node);
          if(rendered(node))emit('render',p,d);
          if(e.intersectionRatio>=.5&&visible(node))timers.set(node,win.setTimeout(function(){timers.delete(node);if(visible(node))emit('visible',p,d);},1000));
        });},{threshold:[0,.5,1]});observer.observe(node);observers.push(observer);
      });
    }
    emit('pageview','page','none');observe();
    doc.addEventListener('click',function(event){var node=event.target.closest('a,button');if(!node||!node.matches(selector)||node.closest('[hidden],[inert],[aria-hidden="true"]'))return;
      var d=destination(node);if(d){emit('render',position(node),d);emit('click',position(node),d);}},true);
    doc.querySelectorAll('[data-nb-protocol-optin]').forEach(function(protocol){
      var p=protocol.closest('.nb-rte')?'protocol':'tail_protocol',form=protocol.querySelector('form');
      if(protocol.querySelector('[data-nb-protocol-success]'))emit('form_accepted',p,'protocol');
      if(form)form.addEventListener('submit',function(){if(!protocol.closest('[hidden],[inert]')&&form.checkValidity())emit('submit_attempt',p,'protocol');});
    });
    doc.addEventListener('visitorConsentCollected',function(){
      // Start a new consented pageview only from this moment. No pre-consent
      // click/visibility history is replayed into the behavioral ledger.
      if(!allowed()){pageview=null;consented.clear();return;}
      emit('pageview','page','none');observe();
    });
    doc.addEventListener('shopifyCustomerPrivacyApiLoaded',function(){if(allowed()){emit('pageview','page','none');observe();}});
    doc.addEventListener('visibilitychange',function(){if(doc.visibilityState==='visible')observe();else{timers.forEach(function(t){win.clearTimeout(t);});timers.clear();}});
    if(win.MutationObserver){
      var mutations=new win.MutationObserver(function(){
        if(refreshTimer!==null)return;
        refreshTimer=win.setTimeout(function(){refreshTimer=null;if(doc.visibilityState!=='hidden')observe();},0);
      });
      mutations.observe(body,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','inert','aria-hidden','href']});
    }
    win.addEventListener('pagehide',function(){
      if(refreshTimer!==null){win.clearTimeout(refreshTimer);refreshTimer=null;}
      timers.forEach(function(t){win.clearTimeout(t);});timers.clear();observers.forEach(function(o){o.disconnect();});
    });
    // Browser back can restore this document from bfcache without running boot.
    // Resume visibility checks while retaining the page's deduplication sets.
    win.addEventListener('pageshow',function(event){if(event.persisted)observe();});
  }
  if(typeof module==='object'&&module.exports)module.exports={boot:boot};
  if(root&&root.document)boot(root.document,root);
})(typeof window==='undefined'?null:window);
